import axiosConfig from "../../config/axios";

export const getCustomerDetails = profileId => {
  return axiosConfig({
    url: `/customers/${profileId}/`,
    method: "GET"
  });
};

export const getAsistantCustomerDetails = (assistantID, profileId) => {
  return axiosConfig({
    url: `assistants/${assistantID}/customers/${profileId}/`,
    method: "GET"
  });
};

export const postCustomerInfo = (profileId, payload) => {
  return axiosConfig({
    url: `/customers/${profileId}/profile/`,
    method: "post",
    data: payload
  });
};

export const getCustomerBasicDetails = profileId => {
  return axiosConfig({
    url: `/customers/${profileId}/user/`,
    method: "get"
  });
};

export const getCustomerGeneralInfo = profileId => {
  return axiosConfig({
    url: `/customers/${profileId}/profile/`,
    method: "get"
  });
};

export const getCustomerAddress = profileId => {
  return axiosConfig({
    url: `/customers/${profileId}/address/`,
    method: "GET"
  });
};

export const patchCustomerAddress = (profileId, address_id, payload) => {
  return axiosConfig({
    url: `/customers/${profileId}/address/${address_id}/`,
    data: payload,
    method: "PATCH"
  });
};

export const postCustomerAddress = (profileId, payload) => {
  return axiosConfig({
    url: `/customers/${profileId}/address/`,
    data: payload,
    method: "POST"
  });
};

export const patchCustomerBasicDetails = (profileId, user_id, payload) => {
  return axiosConfig({
    url: `/customers/${profileId}/user/${user_id}/`,
    data: payload,
    method: "PATCH"
  });
};

export const patchCustomerOtherDetails = (
  primaryProfileId,
  profile_id,
  payload
) => {
  return axiosConfig({
    url: `/customers/${primaryProfileId}/profile/${profile_id}/`,
    data: payload,
    method: "PATCH"
  });
};

export const getCustomer = profileID => {
  return axiosConfig({
    url: `/customers/${profileID}/`,
    method: "get"
  });
};

export const assignPA = (profileId, payload) => {
  return axiosConfig({
    url: `/customers/${profileId}/assistants/`,
    method: "post",
    data: payload
  });
};

export const patchCommunications = (primaryProfileId, payload) => {
  return axiosConfig({
    url: `/customers/${primaryProfileId}/communications/`,
    data: payload,
    method: "PATCH"
  });
};

export const postCommunications = (primaryProfileId, payload) => {
  return axiosConfig({
    url: `/customers/${primaryProfileId}/communications/`,
    data: payload,
    method: "post"
  });
};

export const getCustomerCommunications = primaryProfileId => {
  return axiosConfig({
    url: `/customers/${primaryProfileId}/communications/`,
    method: "GET"
  });
};

export const getCustomers = params => {
  return axiosConfig({
    url: `/customers/`,
    method: "get",
    params: {
      ordering: "user__first_name",
      ...params
    }
  });
};

export const getActiveCustomers = id => {
  return axiosConfig({
    url: `assistants/${id}/customers/`,
    method: "GET",
    params: {
      ordering: "customer__user__first_name",
      customer__is_active: true
    }
  });
};
export const getActiveCustomersMinimal = id => {
  return axiosConfig({
    url: `assistants/${id}/customers/`,
    method: "GET",
    params: {
      type: "minimal",
      ordering: "customer__user__first_name",
      customer__is_active: true
    }
  });
};

export const getAdminsActiveCustomers = id => {
  return axiosConfig({
    url: `admins/${id}/customers/`,
    method: "GET",
    params: {
      ordering: "customer__user__first_name",
      customer__is_active: true
    }
  });
};

export const getAdminsActiveCustomersMinimal = id => {
  return axiosConfig({
    url: `admins/${id}/customers/`,
    method: "GET",
    params: {
      type: "minimal",
      ordering: "customer__user__first_name",
      customer__is_active: true
    }
  });
};

export const getAssignedAssistantsList = primaryProfileId => {
  return axiosConfig({
    url: `/customers/${primaryProfileId}/assistants/`,
    method: "GET",
    params: {
      ordering: "assistant__user__first_name",
      customer__is_active: true,
      is_active: true
    }
  });
};

export const postAssignedAssistantsList = (primaryProfileId, payload) => {
  return axiosConfig({
    url: `/customers/${primaryProfileId}/assistants/`,
    method: "POST",
    data: payload
  });
};

// Owner assignment - deliberately separate from the assistant endpoints so
// the EA dropdowns keep returning EAs only.
export const getOwnersList = params => {
  return axiosConfig({
    url: `/owners/`,
    method: "GET",
    params: {
      ordering: "user__first_name",
      is_active: true,
      ...params
    }
  });
};

export const getAssignedOwnersList = primaryProfileId => {
  return axiosConfig({
    url: `/customers/${primaryProfileId}/owners/`,
    method: "GET",
    params: {
      ordering: "owner__user__first_name"
    }
  });
};

export const postAssignedOwner = (primaryProfileId, payload) => {
  return axiosConfig({
    url: `/customers/${primaryProfileId}/owners/`,
    method: "POST",
    data: payload
  });
};

export const deleteAssignedOwner = (primaryProfileId, assignmentId) => {
  return axiosConfig({
    url: `/customers/${primaryProfileId}/owners/${assignmentId}/`,
    method: "DELETE"
  });
};

export const archiveOrDeleteAccount = payload => {
  return axiosConfig({
    url: `archive-profiles/`,
    data: payload,
    method: "POST"
  });
};

export const getAllArchivedOrDeletedAccounts = () => {
  return axiosConfig({
    url: `archive-profiles/`,
    method: "GET"
  });
};

export const unarchiveCustomerAccount = id => {
  return axiosConfig({
    url: `archive-profiles/${id}/`,
    method: "DELETE"
  });
};

export const getForm = () => {
  return axiosConfig({
    url: `/forms/?form_type=CUSTOMER_ONBOARDING_INTAKE`,
    method: "get"
  });
};

export const formSubmission = (formID, payload) => {
  return axiosConfig({
    url: `/forms/${formID}/submissions/`,
    method: "post",
    data: payload
  });
};

export const getAssistantCustomers = (profileId, params) => {
  return axiosConfig({
    url: `/assistants/${profileId}/customers/`,
    method: "get",
    params: {
      ordering: "customer__user__first_name",
      ...params
    }
  });
};

export const getAdminCustomers = (profileId, params) => {
  return axiosConfig({
    url: `/admins/${profileId}/customers/`,
    method: "get",
    params: {
      ordering: "customer__user__first_name",
      ...params
    }
  });
};

export const getAssistantHandoverCustomers = (profileId, params) => {
  return axiosConfig({
    url: `/assistants/${profileId}/handovercustomers/`,
    method: "GET",
    params
  });
};

export const getAdminHandoverCustomers = profileId => {
  return axiosConfig({
    url: `/admins/${profileId}/handovercustomers/`,
    method: "GET"
  });
};

export const getClientIntakeForm = () => {
  return axiosConfig({
    url: `forms/?form_type=CUSTOMER_PROFILE_INTAKE`,
    method: "GET"
  });
};

export const getFormDetails = form_id => {
  return axiosConfig({
    url: `forms/${form_id}/`,
    method: "GET"
  });
};

export const deleteSelectedAssistants = (primaryProfileId, assistant_id) => {
  return axiosConfig({
    url: `/customers/${primaryProfileId}/assistants/${assistant_id}/`,
    method: "DELETE"
  });
};

export const postSubmissions = (form_id, payload) => {
  return axiosConfig({
    url: `forms/${form_id}/submissions/`,
    data: payload,
    method: "POST"
  });
};

export const patchIntakeSubmissions = (form_id, submission_id, payload) => {
  return axiosConfig({
    url: `forms/${form_id}/submissions/${submission_id}/`,
    data: payload,
    method: "PATCH"
  });
};

export const getSubmissions = profileId => {
  return axiosConfig({
    url: `customers/${profileId}/intake-submissions/`,
    method: "get"
  });
};

export const getPreferences = profileID => {
  return axiosConfig({
    url: `customers/${profileID}/preferences/`,
    method: "get"
  });
};

export const getPreference = (profileID, prefID) => {
  return axiosConfig({
    url: `customers/${profileID}/preferences/${prefID}`,
    method: "get"
  });
};

export const getCategoryPreferences = (profileID, payload) => {
  return axiosConfig({
    url: `customers/${profileID}/preferences/?categories=${payload}`,
    method: "get"
  });
};

export const postPreferences = (profileID, payload) => {
  return axiosConfig({
    url: `customers/${profileID}/preferences/`,
    method: "post",
    data: payload
  });
};

export const patchPreferences = (profileID, preferenceID, payload) => {
  return axiosConfig({
    url: `customers/${profileID}/preferences/${preferenceID}/`,
    method: "patch",
    data: payload
  });
};

export const deletePreferenceAttachment = (
  profileID,
  preferenceID,
  attachmentID
) => {
  return axiosConfig({
    url: `customers/${profileID}/preferences/${preferenceID}/attachments/${attachmentID}/`,
    method: "delete"
  });
};

export const postPreferencesAttachment = (profileID, preferenceID, payload) => {
  return axiosConfig({
    url: `customers/${profileID}/preferences/${preferenceID}/attachments/`,
    method: "post",
    data: payload
  });
};

export const deletePreference = (profileID, preferenceID) => {
  return axiosConfig({
    url: `customers/${profileID}/preferences/${preferenceID}/`,
    method: "delete"
  });
};

export const getPreferenceChecklist = preferenceID => {
  return axiosConfig({
    url: `/preferences/${preferenceID}/checklists/`,
    method: "GET"
  });
};

export const postPreferenceCheckList = (preferenceID, payload) => {
  return axiosConfig({
    url: `/preferences/${preferenceID}/checklists/`,
    method: "POST",
    data: payload
  });
};

export const postPreferenceChecklistOption = (
  preferenceID,
  checklistsID,
  payload
) => {
  return axiosConfig({
    url: `preferences/${preferenceID}/checklists/${checklistsID}/options/`,
    method: "post",
    data: payload
  });
};

export const deletePreferenceChecklistOption = (
  preferenceID,
  checklistsID,
  payload
) => {
  return axiosConfig({
    url: `preferences/${preferenceID}/checklists/${checklistsID}/options/`,
    method: "DELETE",
    data: payload
  });
};

export const deletePreferenceChecklist = (preferenceID, checklistsID) => {
  return axiosConfig({
    url: `preferences/${preferenceID}/checklists/${checklistsID}/`,
    method: "DELETE"
  });
};

export const patchPreferenceChecklist = (
  preferenceID,
  checklistsID,
  payload
) => {
  return axiosConfig({
    url: `preferences/${preferenceID}/checklists/${checklistsID}/`,
    method: "PATCH",
    data: payload
  });
};

export const postTask = payload => {
  return axiosConfig({
    url: `tasks/`,
    method: "post",
    data: payload
  });
};

export const postTaskAttachments = (taskID, payload) => {
  return axiosConfig({
    url: `tasks/${taskID}/attachments/`,
    method: "post",
    data: payload
  });
};

export const postTaskChecklist = (taskID, payload) => {
  return axiosConfig({
    url: `tasks/${taskID}/checklists/`,
    method: "post",
    data: payload
  });
};

export const patchTaskChecklist = (taskID, checklistsID, payload) => {
  return axiosConfig({
    url: `tasks/${taskID}/checklists/${checklistsID}/`,
    method: "patch",
    data: payload
  });
};

export const postTaskChecklistOption = (taskID, checklistsID, payload) => {
  return axiosConfig({
    url: `tasks/${taskID}/checklists/${checklistsID}/options/`,
    method: "post",
    data: payload
  });
};

export const getChecklists = taskId => {
  return axiosConfig({
    url: `tasks/${taskId}/checklists/`,
    method: "get"
  });
};

export const getAttachments = taskId => {
  return axiosConfig({
    url: `tasks/${taskId}/attachments/`,
    method: "get"
  });
};

export const postTaskComments = (taskID, payload) => {
  return axiosConfig({
    url: `tasks/${taskID}/comments/`,
    method: "post",
    data: payload
  });
};

export const getComments = (taskId, params) => {
  return axiosConfig({
    url: `tasks/${taskId}/comments/`,
    method: "get",
    params
  });
};

export const patchComment = (taskId, commentId, payload) => {
  return axiosConfig({
    url: `tasks/${taskId}/comments/${commentId}/`,
    method: "patch",
    data: payload
  });
};

export const deleteComment = (taskId, commentId) => {
  return axiosConfig({
    url: `tasks/${taskId}/comments/${commentId}/`,
    method: "delete"
  });
};

export const getTask = taskID => {
  return axiosConfig({
    url: `tasks/${taskID}/`,
    method: "get"
  });
};

export const deleteTask = taskID => {
  return axiosConfig({
    url: `tasks/${taskID}/`,
    method: "delete"
  });
};

export const archiveTask = (taskID, payload) => {
  return axiosConfig({
    url: `tasks/${taskID}/`,
    method: "PATCH",
    data: payload
  });
};

export const getCustomerReports = (limit, offset, params) => {
  return axiosConfig({
    url: `customer-reports/`,
    method: "get",
    params: {
      limit: limit,
      offset: offset,
      ...params
    }
  });
};

export const getCustomerReportGraphs = params => {
  return axiosConfig({
    url: `report-graphs/`,
    method: "get",
    params
  });
};

export const downloadReports = params => {
  return axiosConfig({
    url: `customer-reports-download/`,
    method: "get",
    params
  });
};

export const getCustomerReportDetails = (
  profileId,
  from,
  to,
  category,
  assignedTo
) => {
  // Build params via axios so null/undefined (e.g. "no EA selected") are
  // dropped instead of being sent as the literal string "null", which the
  // backend matched against no real assistant and returned blank data for.
  return axiosConfig({
    url: `customer-reports/${profileId}/`,
    method: "get",
    params: {
      completed_lte: to,
      completed_gte: from,
      categories: category || null,
      assigned_to: assignedTo
    }
  });
};

export const getCurrentCustomers = (limit, offset, params) => {
  return axiosConfig({
    url: `/customers/`,
    method: "get",
    params: {
      limit: limit,
      offset: offset,
      is_assistant_assigned: true,
      is_active: true,
      ordering: "user__first_name",
      ...params
    }
  });
};

export const getUnassignedCustomers = (limit, offset, params) => {
  return axiosConfig({
    url: `/customers/`,
    method: "get",
    params: {
      limit: limit,
      offset: offset,
      is_assistant_assigned: false,
      is_active: true,
      ordering: "user__first_name",
      ...params
    }
  });
};

export const getArchivedCustomers = (limit, offset, params) => {
  return axiosConfig({
    url: `/customers/`,
    method: "get",
    params: {
      limit: limit,
      offset: offset,
      is_active: false,
      ordering: "user__first_name",
      ...params
    }
  });
};

export const getFilterCustomers = params => {
  return axiosConfig({
    url: `/customers/`,
    method: "get",
    params: {
      type: "filter",
      ordering: "-is_active, user__first_name",
      ...params
    }
  });
};

export const getReportDetailsTasks = (profileId, params) => {
  return axiosConfig({
    url: `/customer-reports/${profileId}/tasks/`,
    params
  });
};

export const getTimeTrackers = (customerId, params) => {
  return axiosConfig({
    url: `/customers/${customerId}/trackers/`,
    method: "get",
    params: {
      ...params
    }
  });
};

export const getCompanies = () => {
  return axiosConfig({
    url: `/companies/`,
    method: "GET"
  });
};

export const sendMonthlyReport = payload => {
  return axiosConfig({
    url: `/report-monthly-usage`,
    method: "POST",
    data: payload
  });
};

export const sendPDFReport = payload => {
  return axiosConfig({
    url: `/pdf-usage-report`,
    method: "POST",
    data: payload
  });
};

export const getReportSubscriptions = params => {
  return axiosConfig({
    url: `/reports/subscriptions/`,
    method: "GET",
    params
  });
};

export const getReportTimerCorrections = params => {
  return axiosConfig({
    url: `/reports/timer-corrections/`,
    method: "GET",
    params
  });
};
